import { useEffect, useState } from "react"; 
import Reports from "./Reports";
import WorkInProgress from "./WorkInProgress";
import TabItems from "../../../core/common/TabItems";
import Footer from "../../../core/common/Footer"; 
import useApi from "../../../core/customhook/useApi";
import webservice_url from "../../../core/webservice/Webservice_url";
import { PageLoader } from "../../../core/common/loader/PageLoader"; 
// import PendingLogin from "./applicant-invited/PendingLogin";

// Strict type
type TabLabel =
  // "Application Submitted"
  | "Work In Progress"
  // | "Interim Reports"
  | "Reports";

type TabItem = {
  status_id: string;
  label: TabLabel;
  count: number;
};

// FIX: Store COMPONENT, not JSX
const componentMap: Record<TabLabel, React.ComponentType<any>> = {
  // "Application Submitted": ApplicationSubmitted,
  "Work In Progress": WorkInProgress,
  // "Interim Reports": InterimReports,
  "Reports": Reports
};

const TrackCaseProgram = () => {
  const [activeTab, setActiveTab] = useState<string>("");

  // API
  const { data: tabCount, loading } = useApi(webservice_url.fetch_live_case_progress_count, {
    method: "GET",
    autoCall: true,
  });

  //  Build tabs with Component reference
  const dynamicTabs =
    (tabCount?.data as TabItem[] | undefined)?.map((item) => ({
      id: item?.label,
      status_id: item?.status_id ?? "",
      label: item?.label,
      count: item?.count,
      Component: componentMap[item?.label], //  correct
    })) ?? [];


  //  Set default tab

  useEffect(() => {
    if (dynamicTabs.length === 0) return;
    const exists = dynamicTabs.some(tab => tab?.label === activeTab);

    if (!exists) {
      setActiveTab(dynamicTabs[0]?.label);
    }
  }, [dynamicTabs, activeTab]);

  const activeTabData = dynamicTabs?.find((tab) => tab?.label === activeTab);
  const ActiveComponent = activeTabData?.Component;

  //  Restore from localStorage
  useEffect(() => {
    const storedTab = localStorage.getItem("admin-active-track-case-tab");
    if (storedTab) {
      setActiveTab(storedTab);
    }
  }, []);

  return (
    <div className="page-wrapper">
      <div className="content p-2 p-md-3">
        {loading
          ? <PageLoader />
          : <>
            <TabItems
              tabList={dynamicTabs}
              activeTab={activeTab}
              handleClick={(d) => {
                setActiveTab(d?.label);
                localStorage.setItem("admin-active-track-case-tab", d?.label);
              }}
            />
            {/* Tab Content */}
            <div className="mt-4 pt-2">{ActiveComponent && <ActiveComponent status_id={activeTabData?.status_id} />}</div>
          </>
        }
      </div>
      <Footer />
    </div>
  );
};

export default TrackCaseProgram;

// import { useEffect, useState } from "react";
// import ApplicantInvited from "./ApplicantInvited";
// import HrPendingAction from "./HrPendingAction";
// import InterimReports from "./InterimReports";
// import Reports from "./Reports";
// import RevisedDateCases from "./RevisedDateCases";
// import StoppedCases from "./StoppedCases";
// import WorkInProgress from "./WorkInProgress";
// import TabItems from "../../../core/common/TabItems";
// import Footer from "../../../core/common/Footer";
// import {
//   dummyData_finalReport,
//   dummyData_invited,
//   dummyData_recheckReport,
//   dummyData_revisedDate,
//   dummyData_stoppedCases,
//   dummyData_submitted,
//   dummyData_WorkInProgress,
// } from "../../../core/data/js/dummy-data";
// import ApplicationSubmitted from "./ApplicationSubmitted";

// const reportsCount =
//   dummyData_finalReport?.length + dummyData_recheckReport?.length;

// // Tabs Config
// const tabs = [
//   {
//     id: "applicantSubmitted",
//     label: "Application Submitted",
//     count: dummyData_submitted?.length || 0,
//     component: <ApplicationSubmitted />,
//   },
//   {
//     id: "workInProgress",
//     label: "Work In Progress",
//     count: dummyData_WorkInProgress?.length || 0,
//     component: <WorkInProgress />,
//   },
//   {
//     id: "interimReports",
//     label: "Interim Reports",
//     count: dummyData_finalReport?.length || 0,
//     component: <InterimReports />,
//   },
//   {
//     id: "reports",
//     label: "Reports",
//     count: reportsCount,
//     component: <Reports />,
//   },
// ];

// const TrackCaseProgram = () => {
//   const [activeTab, setActiveTab] = useState(tabs[0]?.id);

//   useEffect(() => {
//     const storedTab = localStorage.getItem("admin-active-track-case-tab");
//     if (storedTab) {
//       setActiveTab(storedTab);
//     }
//   }, []);

//   return (
//     <div className="page-wrapper">
//       <div className="content p-2 p-md-3">
//         {/* Tabs */}
//         <TabItems
//           tabList={tabs}
//           activeTab={activeTab}
//           handleClick={(d) => {
//             setActiveTab(d.id);
//             localStorage.setItem("admin-active-track-case-tab", d.id);
//           }}
//         />

//         {/* Tab Content */}
//         <div className="mt-3">
//           {tabs.find((tab) => tab.id === activeTab)?.component}
//         </div>
//       </div>

//       {/* ---- Footer ---- */}
//       <Footer />
//     </div>
//   );
// };

// export default TrackCaseProgram;

// // const tabs = [
// //   {
// //     id: "applicantInvited",
// //     label: "Applicant Invited",
// //     count: dummyData_invited?.length || 0,
// //     component: <ApplicantInvited />,
// //   },
// //   {
// //     id: "applicantSubmitted",
// //     label: "Application Submitted",
// //     count: dummyData_submitted?.length || 0,
// //     component: <ApplicationSubmitted />,
// //   },
// //   {
// //     id: "workInProgress",
// //     label: "Active Cases",
// //     // label: "Work In Progress",
// //     count: dummyData_WorkInProgress?.length || 0,
// //     component: <WorkInProgress />,
// //   },
// //   {
// //     id: "hrPendingAction",
// //     label: "HR Action Required",
// //     // label: "HR Pending Action",
// //     count: 77,
// //     component: <HrPendingAction />,
// //   },
// //   {
// //     id: "revisedDateCases",
// //     label: "Revised TAT Cases",
// //     // label: "Revised Date Cases",
// //     count: dummyData_revisedDate?.length || 0,
// //     component: <RevisedDateCases />,
// //   },
// //   {
// //     id: "interimReports",
// //     label: "Interim Reports",
// //     count: dummyData_finalReport?.length || 0,
// //     component: <InterimReports />,
// //   },
// //   {
// //     id: "reports",
// //     label: "Reports",
// //     count: reportsCount,
// //     component: <Reports />,
// //   },
// //   {
// //     id: "stoppedCases",
// //     label: "Stopped Cases",
// //     // label: "Stopped",
// //     count: dummyData_stoppedCases?.length || 0,
// //     component: <StoppedCases />,
// //   },
// // ];
